import { makeEndpointFns } from './fns';
import { DsiData } from '@whiz-cart/node-shared/dsi/dsiData';
import { DsiAdditionalModel } from '@whiz-cart/node-shared/models/dsi/dsiAdditionalModel';
import { DsiInspectionConfirmationResult, DsiInspectionResult } from '@whiz-cart/node-shared/models/dsi/dsiInspection';
import { DsiIssue, DsiIssueDraft } from '@whiz-cart/node-shared/models/dsi/dsiIssue';
import { DsiLabellingData, DsiLabellingDraft } from '@whiz-cart/node-shared/models/dsi/dsiLabelling';
import { DsiSession } from '@whiz-cart/node-shared/models/dsi/dsiSession';
import {
    DsiAdditionalModelReview,
    DsiFinishSessionDto,
    DsiSessionsResponse,
    DsiSuspiciousSessionsFilter,
    type DsiSessionsFilter,
} from '@whiz-cart/node-shared/models/dsi/sessions';
import z from 'zod';

const { URL, GET, POST, PUT, DELETE } = makeEndpointFns('dsi');

export const dsiEndpoints = {
    websocket: URL(''),
    getSessions: POST<'sessions', DsiSessionsResponse, DsiSessionsFilter>('sessions', DsiSessionsResponse),
    getSessionByGuid: GET('sessions/{sessionGuid}', DsiData),
    getDsiSessionByGuid: GET('sessions/dsi-sessions/{sessionGuid}', DsiSession),
    getImageLabels: GET('imageLabelling/{sessionGuid}', DsiLabellingData.array()),
    lockSession: POST.void('analyze/{sessionGuid}/lock'),
    lockSessionForce: POST.void('analyze/{sessionGuid}/lock/force'),
    unlockSession: DELETE.void('analyze/{sessionGuid}/lock'),
    unlockSessionForce: DELETE.void('analyze/{sessionGuid}/lock/force'),
    updateIssue: POST.void('analyze/{sessionGuid}/issue', { body: z.union([DsiIssue, DsiIssueDraft]) }),
    deleteIssue: DELETE.void('analyze/{sessionGuid}/issue/{issueGuid}'),
    finishSession: POST('analyze/{sessionGuid}/finish', DsiSession, { body: DsiFinishSessionDto }),
    updateImageLabel: POST.void('imageLabelling', { body: DsiLabellingDraft }),
    deleteImageLabel: POST.void('imageLabelling/{sessionGuid}/{correlationGuid}/{url}'),
    suspicious: {
        getSessions: POST('inspections/suspicious-sessions', DsiSessionsResponse, { body: DsiSuspiciousSessionsFilter }),
        getSessionsToConfirm: POST('inspections/suspicious-sessions/confirm', DsiSessionsResponse, { body: DsiSuspiciousSessionsFilter }),
        setInspection: PUT.void<'inspections/suspicious-sessions/{sessionGuid}', { result: DsiInspectionResult | null }>(
            'inspections/suspicious-sessions/{sessionGuid}',
        ),
        setInspections: PUT.void<'inspections/suspicious-sessions', { results: Record<string, DsiInspectionResult | null> }>(
            'inspections/suspicious-sessions',
        ),
        setInspectionConfirmation: PUT.void<
            'inspections/suspicious-sessions/confirm/{sessionGuid}',
            { result: DsiInspectionConfirmationResult }
        >('inspections/suspicious-sessions/confirm/{sessionGuid}'),
    },
    additional: {
        getModels: GET('additionalModels', DsiAdditionalModel.array()),
        getModelSessions: POST<'sessions/{modelId}', DsiSessionsResponse, DsiSessionsFilter>('sessions/{modelId}', DsiSessionsResponse),
        setModelReview: POST.void('sessions/additionalClassifications/{modelId}', { body: DsiAdditionalModelReview }),
    },
};
